/*
 * JS module for Participant (Advanced) Search
*/
rs.module("participant/search",

    /* dependencies */
    [],

    function () {

        //
        // Module initialization
        //
        function initialize(jsSelectors, backendUrls) {

            var searchContainer = $.js(jsSelectors.searchContainer);
            var searchInput = searchContainer.js(jsSelectors.searchInput);
            var searchButton = searchContainer.js(jsSelectors.searchButton);
            var searchIcon = searchContainer.js(jsSelectors.searchIcon);
            var spinner = searchContainer.js(jsSelectors.loadingSpinner);
            var includeHistoryCheckBox = searchContainer.js(jsSelectors.includeHistoryCheckBox);
            var searchResultsContainer = $.js(jsSelectors.searchResultsContainer);

            // Handle search button click event
            searchButton.click(function () {
                initiateSearch();
            });

            // Handle Enter press within search input
            searchInput.on("keydown",
                function (event) {
                    if (event.which == 13) {
                        initiateSearch();
                    }
                }
            );

            //
            // Initiate the search
            //
            function initiateSearch() {

                var query = searchInput.val().trim();
                var includeHistory = includeHistoryCheckBox.is(":checked");

                searchIcon.hide();
                // set to inline-block so the animations work  
                spinner.css('display', 'inline-block');

                $.get(

                    backendUrls.search,

                    {
                        "query": query,
                        "includeHistory": includeHistory
                    },

                    function (data) {
                        searchResultsContainer.html(data);
                    }
                ).always(function () {
                    searchIcon.show();
                    spinner.css('display', 'none');
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);